import * as settlement from 'services/settlement';

export const SETTLEMENT_TRADING_LIST = 'SETTLEMENT_TRADING_LIST';
export const SETTLEMENT_TRADING_INFO = 'SETTLEMENT_TRADING_INFO';
export const SETTLEMENT_META_INFO = 'SETTLEMENT_META_INFO';
export const SETTLEMENT_TAX_INVOICE = 'SETTLEMENT_TAX_INVOICE';
export const SETTLEMENT_BANK_DEPOSIT = 'SETTLEMENT_BANK_DEPOSIT';
export const SETTLEMENT_PROGRESS_STATUS = 'SETTLEMENT_PROGRESS_STATUS';

// 정산관리 리스트
export const SettlementTradingList = (params) => ({
  type: SETTLEMENT_TRADING_LIST,
  payload: {
    promise: settlement.SettlementTradingList(params)
  }
});

// 거래명세서 상세 정보
export const SettlementTradingInfoDetail = (taxUnitSeq) => ({
  type: SETTLEMENT_TRADING_INFO,
  payload: {
    promise: settlement.SettlementTradingInfoDetail(taxUnitSeq)
  }
});

// 정산 고객사 메타 정보
export const SettlementMetaInfoDetail = (type, invoiceIdx, params) => ({
  type: SETTLEMENT_META_INFO,
  payload: {
    promise: settlement.SettlementMetaInfoDetail(type, invoiceIdx, params)
  }
});

// 정산 세금계산서 리스트
export const SettlementTaxInvoice = (params) => ({
  type: SETTLEMENT_TAX_INVOICE,
  payload: {
    promise: settlement.SettlementTaxInvoice(params)
  }
});

// 은행입금 리스트
export const SettlementBankDeposit = (taxUnitSeq, params) => ({
  type: SETTLEMENT_BANK_DEPOSIT,
  payload: {
    promise: settlement.SettlementBankDeposit(taxUnitSeq, params)
  }
});

// 정산 진행상태
export const SettlementProgressStatus = (taxUnitSeq, params) => ({
  type: SETTLEMENT_PROGRESS_STATUS,
  payload: {
    promise: settlement.SettlementProgressStatus(taxUnitSeq, params)
  }
});
